var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.002,
    height: 12.007,
    viewBox: "0 0 10.002 12.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deletes",
    transform: "translate(-96.038 -64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M105.968,66.169c-.075-.281-.125-.438-.125-.438-.081-.291-.288-.291-.594-.341l-1.66-.209c-.206-.034-.206-.034-.288-.213-.272-.613-.356-.969-.653-.969h-3.22c-.3,0-.378.356-.65.972-.081.175-.081.175-.288.213l-1.663.209c-.3.05-.522.078-.6.369,0,0-.038.128-.116.406-.1.372-.141.331.2.331h9.453C106.109,66.5,106.071,66.541,105.968,66.169Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M124.152,176h-7.715c-.519,0-.544.071-.513.472l.585,7.789c.05.395.088.475.547.475h6.477c.46,0,.5-.08.547-.475l.585-7.789C124.7,176.067,124.67,176,124.152,176Z",
    transform: "translate(-19.256 -108.729)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletes);
export default __webpack_public_path__ + "static/media/Deletes.174908aac8ec6dd9be2491f4edf96def.svg";
export { ForwardRef as ReactComponent };